import { put, call, takeLatest } from "redux-saga/effects";

import * as Actions from "redux/actions/InitFormActions";
import * as Types from "redux/constants/InitFormConstants";

import RecordsService from "services/InitFormService";

export function* fetchRecordsEffect() {
    try {
        const { data: records } = yield call(RecordsService.fetchRecords);
        yield (put(Actions.fetchRecordsOk(records)));
        // console.log("Records: ", records)

    } catch ({ response }) {
        yield (
            put(
                Actions.fetchRecordsFailed({
                    status: response.status,
                    message: response.data.message,
                    errors: []
                })
            )
        );
    }
}


export default function* rootSaga() {
    yield takeLatest(Types.FETCH_RECORDS, fetchRecordsEffect);

}
